const en = {
  myCalls: 'My calls',
  waitingForExpertResponse: 'Waiting for expert\'s response',
  departmentsPermissions: 'Departments permissions',
  affiliatesCommissionsSettlements: 'Commissions',
  affiliatesCommissionsSettlementsItems: 'Commissions items',
  lastExpert: 'Last expert',
  visit: 'Visit',
  dashboard: 'Dashboard',
  advancedDashboard: 'Advanced Dashboard',
  layoutBuilder: 'Layout builder',
  craft: 'Crafted',
  pages: 'Pages',
  profile: 'Profile',
  profileOverview: 'Overview',
  projects: 'Projects',
  campaigns: 'Campaigns',
  documents: 'Documents',
  connections: 'Connections',
  wizards: 'Wizards',
  horizontal: 'Horizontal',
  vertical: 'Vertical',
  fileManages: 'File Manages',
  folders: 'Folders',
  files: 'Files',
  deleteFiles: 'Delete files',
  uploadFile: 'Upload File',
  newFolder: 'New folder',
  choices: 'Choices',
  blank: 'Blank',
  addNewItemLabel: 'Add {name}',
  editItemLabel: 'Edit {name}',
  enterLabelField: 'Enter the {name}',
  selectField: 'Select {name}',
  select: 'Select',
  tickets: 'Tickets',
  myTickets: 'My Tickets',
  chatwoot: 'Chatwoot',
  chatwootInbox: 'Inbox',
  onlineChatBeta: 'Online chat (beta)',  betaFeatures: 'Beta features',
  betaFeaturesPageHint: 'Turn a feature on for everyone, or only for specific users. If it is on for everyone, you can still exclude specific users.',
  featureEnabledForEveryone: 'Enabled for everyone',
  featureEnabledForEveryoneHint: 'When on, the feature is enabled for all current and new users, except the users you exclude below.',
  featureEnabledForActiveTermUsers: 'Enabled for active-term users',
  featureEnabledForActiveTermUsersHint: 'When on, the feature is enabled for anyone with an active term, regardless of the everyone switch.',
  featureEnabledForLoggedInUsers: 'Enabled for logged-in users',
  featureEnabledForLoggedInUsersHint: 'When on, the feature is enabled for any logged-in user, regardless of the everyone switch.',
  featureEnabledForLoggedOutUsers: 'Enabled for logged-out users',
  featureEnabledForLoggedOutUsersHint: 'When on, the feature is enabled for guests (not logged in), regardless of the everyone switch.',
  featureUsersTitle: 'Users with their own setting',
  featureManageUsers: 'Manage users',
  featureUsersAllowHint: 'The feature is off by default, so it is on only for the users marked "Enabled" below.',
  featureUsersDenyHint: 'The feature is on for everyone except the users marked "Disabled" below.',
  featureUsersInactiveHint: 'Dimmed users have a setting that changes nothing while the switch above is where it is now. It applies again if you flip the switch.',
  featureUserInactive: 'No effect right now',
  featureAddUserDrawerTitle: 'Add a user with their own setting',
  featureAddUserDrawerHint: 'Choose whether the selected user has "{feature}", regardless of the everyone switch.',
  featureEnabled: 'Enabled',
  featureDisabled: 'Disabled',
  ticketDepartments: 'Departments',
  ticketDepartment: 'Department',
  departmentUsers: 'Department users',
  requestDetails: 'Request Details',
  placeholderLabelEnterField: 'Enter the {name}',
  user: 'User',
  subject: 'Subject',
  priority: 'Priority',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  urgent: 'Urgent',
  new: 'New',
  inProgress: 'In progress',
  waitingForUser: 'Waiting for user',
  closed: 'Closed',
  closedAt: 'Closed at',
  name: 'Name',
  mobile: 'Mobile',
  mimeType: 'Mime Type',
  size: 'Size',
  lastUpdate: 'Last Update',
  description: 'Description',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  actions: 'Actions',
  selectDate: 'Select date',
  deleteSelectedFiles: 'Are you sure you want to delete the selected files?',
  deleteSelectedFile: 'Are you sure you want to delete this file?',
  deleteSelectedItem: 'Are you sure you want to delete this item?',
  deleteSelectedItems: 'Are you sure you want to delete the selected items?',
  yes: 'Yes',
  no: 'No',
  search: 'Search',
  searchInLabel: 'Search in {name}',
  searchByMobileOrID: 'Search by mobile or ID',
  requestedByUser: 'Requested by user',
  appliedByAdmin: 'Applied by admin',
  statusDateType: 'Status date range type',
  createdAtRange: 'Created date',
  appliedAtRange: 'Applied date range',
  rejectedAtRange: 'Rejected date range',
  ComposeYourContent: 'Compose your content...',
  dragAndDropFilesHelp: 'Drag and drop files here or',
  tenant: 'Tenant',
  rolesPermissions: 'Roles & Permissions',
  changePassword: 'Change Password',
  accessManagement: 'Access management',
  permissions: 'Permissions',
  roles: 'Roles',
  foods: 'Foods',
  food: 'Food',
  foodItems: 'Food Items',
  foodItem: 'Food Item',
  foodItemTitle: 'Food Item Title',
  foodItemType: 'Food Item Type',
  addFoodItem: 'Add food item',
  basicInformation: 'Basic information',
  image: 'Image',
  nutritionalValue: 'Nutritional value',
  nutritionalInformation: 'Nutritional information',
  unitConversion: 'Unit conversion',
  basicFoodItemInformation: 'Basic food item information',
  imageSelection: 'Image selection',
  foodRelatedIllnesses: 'Food-related illnesses',
  unitConversionFromGrams: 'Unit conversion from grams',
  editFoodItem: 'Edit food item',
  unit: 'Unit',
  coefficientInGrams: 'Coefficient in grams',
  step: 'Step',
  nutritionalValuePerGram: 'Nutritional value per gram',
  caloriesPerUnit: 'Calories per unit',
  calories: 'Calories',
  totalCalories: 'Total calories',
  carbohydrate: 'Carbohydrate',
  fat: 'fat',
  protein: 'Protein',
  diseaseName: 'Disease name',
  theConnectionBetweenFoodAndDisease: 'The connection between food and disease',
  good: 'It is good',
  caution: 'Not recommended',
  avoid: 'Strongly not recommended',
  dangerous: 'It is dangerous',
  language: 'Language',
  default: 'Default',
  preview: 'Preview',
  account: 'Account',
  accountOverview: 'Overview',
  settings: 'Settings',
  authentication: 'Authentication',
  basicFlow: 'Basic Flow',
  signIn: 'Sign-in',
  signUp: 'Sign-up',
  passwordReset: 'Password Reset',
  forgotPassword: 'Forgot Password?',
  multiStepSignUp: 'Multi-steps Sign up',
  error404: 'Error 404',
  error500: 'Error 500',
  apps: 'Apps',
  chat: 'Chat',
  privateChat: 'Private Chat',
  groupChat: 'Group Chat',
  drawerChat: 'Drawer Chat',
  widgets: 'Widgets',
  widgetsLists: 'Lists',
  widgetsStatistics: 'Statistics',
  widgetsCharts: 'Charts',
  widgetsMixed: 'Mixed',
  widgetsTables: 'Tables',
  widgetsFeeds: 'Feeds',
  changelog: 'Changelog',
  docsAndComponents: 'Docs & Components',
  megaMenu: 'Mega Menu',
  exampleLink: 'Example link',
  modals: 'Modals',
  general: 'General',
  inviteFriends: 'Invite Friends',
  viewUsers: 'View Users',
  upgradePlan: 'Upgrade Plan',
  shareAndEarn: 'Share & Earn',
  forms: 'Forms',
  newTarget: 'New Target',
  newCard: 'New Card',
  newAddress: 'New Address',
  createAPIKey: 'Create API Key',
  twoFactorAuth: 'Two Factor Auth',
  createApp: 'Create App',
  createAccount: 'Create Account',
  documentation: 'Documentation',
  components: 'Components',
  resources: 'Resources',
  activity: 'Activity',
  customers: 'Customers',
  gettingStarted: 'Getting Started',
  customersListing: 'Customers Listing',
  customerDetails: 'Customers Details',
  calendarApp: 'Calendar',
  subscriptions: 'Subscriptions',
  getStarted: 'Getting Started',
  subscriptionList: 'Subscription List',
  addSubscription: 'Add Subscription',
  viewSubscription: 'View Subscription',
  information: 'Information',
  email: 'Email',
  emailVerifiedAt: 'Email verified at',
  phoneNumber: 'Phone number',
  phoneVerifiedAt: 'Phone verified at',
  colleagues: 'Colleagues',
  list: 'List',
  items: 'Items',
  overview: 'Overview',
  edit: 'Edit',
  details: 'Details',
  fullName: 'Full Name',
  verified: 'Verified',
  magazine: 'Magazine',
  ProductPostSchedule: 'Product Post Schedule',
  dayNumber: 'Day Number',
  tags: 'Tags',
  tag: 'Tag',
  blogs: 'Blogs',
  blog: 'Blog',
  addBlog: 'Add blog',
  editBlog: 'Edit blog',
  editDiet: 'Edit diet',
  addDiet: 'Add diet',
  categoryList: 'Category list',
  draft: 'Draft',
  published: 'Published',
  explanation: 'Explanation',
  foodList: 'Food list',
  meals: 'Meals',
  meal: 'Meal',
  fastingPattern: 'Fasting pattern',
  fastingPatternMeals: 'Meals in fasting patterns',
  fasting: 'Fasting',
  islamicFasting: 'Islamic Fasting',
  title: 'Title',
  order: 'Order',
  mealType: 'Meal Type',
  diseases: 'Diseases',
  editMeal: 'Edit Meal',
  mealTitleIsRequired: 'Meal title is required.',
  mealTitle: 'Meal Title',
  mainMeal: 'Main Meal',
  snack: 'Snack',
  conditionalMeal: 'Conditional Meal',
  quotaMeal: 'Quota Meal',
  icon: 'Icon',
  submit: 'Submit',
  cancel: 'Cancel',
  continue: 'Continue',
  pleaseWait: 'Please wait...',
  back: 'Back',
  mealTypeIsRequired: 'Meal Type is a required field',
  addMeal: 'Add Meal',
  enterMealTitle: 'Enter Meal Title',
  selectMealType: 'Select Meal Type',
  addNewRole: 'Add a new role',
  roleDeletionMessage: 'Are you sure you want to delete the role {name}?',
  choosingAccessLevels: 'Choosing access levels',
  editPermissions: 'Edit permissions',
  addNewPermissions: 'Add new permissions',
  permissionDeletionMessage: 'Are you sure you want to delete the permission {name}?',
  close: 'Close',
  save: 'Save',
  sending: 'Sending...',
  roleEditing: 'Role editing',
  nameIsRequired: 'Name is required.',
  selectingAtLeastOneAccessLevelIsRequired: 'Selecting at least one access level is required.',
  formValidationErrorMessage: 'Sorry, it seems that some errors have been detected, please try again.',
  ok: 'Ok',
  enterTheName: 'Enter the name.',
  createdAt: 'Created at',
  updatedAt: 'Updated at',
  publishedAt: 'Published at',
  guardName: 'Guard name',
  tenantDeletionMessage: 'Are you sure you want to delete tenant {name}?',
  domain: 'Domain',
  enterTheDomain: 'Enter the domain.',
  enterTheIcon: 'Enter the icon.',
  domainIsRequired: 'Domain is required.',
  iconIsRequired: 'Icon is required.',
  addNewTenant: 'Add new Tenant',
  videos: 'Videos',
  images: 'Images',
  audios: 'Audios',
  upload: 'Upload',
  selectFiles: 'Select Files',
  media: 'Media',
  fileManagement: 'File Management',
  uploadToThisGroup: 'Upload to this group:',
  category: 'Category',
  emptyTableMessage: 'There is nothing to display.',
  deleteItems: 'Delete items',
  emptyTableText: 'No data found',
  deleteSelectedMeal: 'Are you sure you want to delete this meal?',
  selectIcon: 'Select Icon',
  noMoreOptions: 'No more options...',
  loading: 'Loading',
  selectTitle: 'Select {name}',
  dynamicLayouts: 'Dynamic layouts',
  layouts: 'Layouts',
  addLayout: 'Add Layout',
  slug: 'Slug',
  type: 'Type',
  repeatable: 'Repeatable',
  slugIsRequired: 'Slug is required.',
  repeatableIsRequired: 'Repeatable is required.',
  layoutTypeIsRequired: 'Layout Type is required.',
  enterLayoutName: 'Enter layout name',
  enterLayoutSlug: 'Enter layout slug',
  process: 'Process',
  page: 'Page',
  customDataHandler: 'Custom data handler',
  enterHandlerName: 'Enter handler name',
  selectLayoutType: 'Select Layout Type',
  layoutType: 'Layout Type',
  deleteSelectedLayout: 'Are you sure you want to delete this layout?',
  editLayout: 'Edit Layout',
  maxCountCharactersAllowed: 'Maximum {count} characters allowed.',
  minCountCharactersAllowed: 'Minimum {count} characters allowed.',
  layoutName: 'Layout name',
  layoutSlug: 'Layout slug',
  validation: {
    required: '{field} is a required field',
    numeric: '{field} must be a number',
    valid: 'Please enter a valid {field}',
    leastCharacters: '{field} must be at least {min} characters',
    passwordsMustMatch: 'Passwords must match',
    min: 'The {field} field must be at least {min}.',
    max: 'The {field} field must be max {max}.',
    totalPercentageMustBe100: 'Total Percentage Must Be 100.',
    invalidIban: 'The Sheba Bank number is invalid.(**** **** **** **** **** ****)',
    invalidCardNumber: 'ّnvalid Card Number.(16 digit)'
  },
  createdSuccessfullyMessage: 'The {name} was created successfully.',
  updatedSuccessfullyMessage: '{name} was successfully updated.',
  sections: 'Sections',
  dynamicBuilder: 'Dynamic builder',
  dynamicbuilder: 'Dynamic builder',
  titleIsRequired: 'Title is required.',
  descIsRequired: 'Description is required.',
  enterSectionTitle: 'Enter section title',
  enterSectionDesc: 'Enter section description',
  addSection: 'Add Section',
  editSection: 'Edit Section',
  sectionTitle: 'Section title',
  definitions: 'Definitions',
  addDisease: 'Add Disease',
  editDisease: 'Edit Disease',
  enterValidNumber: 'Enter a valid number.',
  enterValidEmail: 'Enter a valid email.',
  enterDiseaseTitle: 'Enter disease title',
  enterDiseaseDesc: 'Enter disease description',
  enterDiseaseOrder: 'Enter disease order',
  thisFieldIsRequired: 'This field is required.',
  valueMustBeInteger: 'Value must be an integer.',
  minNumberIs: 'Minimum value is {number}.',
  maxNumberIs: 'Maximum value is {number}.',
  value: 'Value',
  enterCalorieValue: 'Enter calorie value',
  countries: 'Countries',
  enterCountryName: 'Enter country name',
  countryName: 'Country name',
  callingCode: 'Calling code',
  enterCountryCallingCode: 'Enter country calling code',
  code: 'Code',
  enterCountryCode: 'Enter country code',
  addCountry: 'Add Country',
  editCountry: 'Edit Country',
  profileDetails: 'Profile Details',
  editProfile: 'Edit Profile',
  avatar: 'Avatar',
  discard: 'Discard',
  password: 'Password',
  signInMethod: 'Sign-in Method',
  resetPassword: 'Reset Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  updatePassword: 'Update Password',
  yourChangesHaveBeenSavedSuccessFully: 'Your changes have been saved successfully.',
  addColleague: 'Add Colleague',
  enterColleagueName: 'Enter colleague name',
  enterColleaguePassword: 'Enter colleague password',
  enterUserName: 'Enter user name',
  enterUserPassword: 'Enter user password',
  users: 'Users',
  addUser: 'Add User',
  editUser: 'Edit User',
  ifNoChangeIsNeededLeaveBlank: 'If no change is needed, leave blank',
  continueWithGoogle: 'Continue with Google',
  continueWithFacebook: 'Continue with Facebook',
  newAccount: 'New account?',
  createAnAccount: 'Create an Account',
  or: 'OR',
  enterCredentials: 'Enter your login credentials.',
  enterYourMobile: 'Enter your mobile number.',
  enterOtp: 'Otp Code',
  otp: 'OTP code',
  unexpectedErrorOccurred: 'Unexpected error occurred!',
  serverError: 'Server Error!',
  delete: 'Delete',
  operationWasSuccessful: 'Operation was successful',
  personnel: 'Personnel',
  personnels: 'Personnels',
  createPersonnel: 'Creating new personnel',
  editPersonnel: 'Edit personnel',
  personnelProfile: 'Personnel Profile',
  settingsAndConfigs: 'Settings and Configs',
  appVersion: 'Application Version',
  android: 'Android',
  ios: 'iOS',
  web: 'Web',
  all: 'All',
  selectPlatform: 'Select Platform',
  platform: 'Platform',
  version: 'Version',
  enterVersion: 'Enter version',
  updateType: 'Update Type',
  changes: 'Changes',
  releasedAt: 'Released at',
  mandatory: 'Mandatory',
  optional: 'Optional',
  addVersion: 'Add Version',
  forcedUpdate: 'Forced Update',
  enterChanges: 'Enter Changes',
  andNewField: 'Add new field',
  enterValidValue: 'Enter a valid value.',
  period: 'Period',
  public: 'Public',
  foodMenus: 'Food Menus',
  foodMenu: 'Food Menu',
  calorieList: 'Calorie List',
  listOfCalorieRanges: 'List of calorie ranges',
  editFoodMenu: 'Edit Food Menu',
  itCouldBeIslamicFasting: 'Islamic fasting',
  menuPeriod: 'Menu Period',
  customerOrigins: 'Customer Origins',
  customerOrigin: 'Customer Origin',
  paymentGateways: 'Payment gateways',
  defaultPaymentGateway: 'Default Payment gateway',
  packages: 'Packages',
  unsuccessfulPaymentLink: 'Unsuccessful payment link',
  successfulPaymentLink: 'Successful Payment link',
  paymentRedirectUrls: 'Payment redirection URLs',
  applyFilter: 'filter',
  resetFilter: 'Reset',
  startAndEndTime: 'Start and end time',
  startTimeAt: 'Start at',
  endTimeAt: 'End at',
  payments: 'Payments',
  gateway: 'Gateway',
  cardToCard: 'Card to card',
  paymentMethod: 'Payment Method',
  discounts: 'Discounts',
  maximumUse: 'Maximum number of uses',
  frequencyOfUse: 'Frequency of use',
  fromDate: 'From date',
  toDate: 'To date',
  percentage: 'Percentage',
  fixed: 'Fixed',
  addDiscount: 'Add Discount',
  editDiscount: 'Edit Discount',
  discountType: 'Discount Type',
  discountValue: 'Discount Value',
  enterCode: 'Enter code',
  selectDiscountType: 'Select Discount Type',
  enterDiscountValue: 'Enter Discount Value',
  minimumPrice: 'Minimum Price',
  maximumPrice: 'Maximum Price',
  enterMinimumPrice: 'Enter minimum price',
  enterMaximumPrice: 'Enter maximum price',
  assignToUser: 'Assign to user',
  activePeriod: 'Active Period',
  searchPhoneNumber: 'Search phone number',
  addNewItem: 'Add new item',
  backToList: 'Back to list',
  assignedUsers: 'Assigned Users',
  orders: 'Orders',
  userId: 'User ID',
  prices: 'Prices',
  totalPrice: 'Total Price',
  discountAmount: 'Discount Amount',
  finalPrice: 'Final Price',
  pending: 'Pending',
  applied: 'Applied',
  approved: 'Approved',
  paid: 'Paid',
  canceled: 'Canceled',
  needsReview: 'Needs Review',
  shipped: 'Shipped',
  returned: 'Returned',
  assignTicket: 'Assign ticket',
  maxCalory: 'Max Calory',
  minCalory: 'Min Calory',
  range: 'Range',
  day: 'Day',
  copy: 'Copy',
  timeFrame: 'Time frame',
  mealName: 'Meal Name',
  mealCalories: 'Meal Calories',
  fastingMeal: 'Fasting Meal',
  fastingCalories: 'Fasting Calories',
  startAndEndPeriod: 'Start and End Period',
  sequence: 'Sequence',
  fixedAmounts: 'Fixed Amounts',
  fixedAmount: 'Fixed Amount',
  enterMealInformation: 'Enter the nutritional information for the meal.',
  foodMeal: 'Food Meal',
  foodFasting: 'Food Fasting',
  duplicateRecordQuestion: 'Are you sure you want to create a duplicate of this record?',
  numbers: 'Numbers',
  number: 'Number',
  phone: 'Phone',
  bankNumbers: 'Bank of numbers',
  inputChannel: 'Input channel',
  expert: 'Expert',
  experts: 'Experts',
  createdBy: 'Created By',
  resultLastCall: 'Result of the last call',
  numberCalls: 'Number of calls',
  utmCampaign: 'Campaign',
  utmMedium: 'Medium',
  utmSource: 'Source',
  utmContent: 'Content',
  registrationDate: 'Registration date',
  channelUpdateDate: 'Input channel update date',
  numberInformation: 'Number Information',
  requestNumber: 'Request number',
  commandRequests: 'Command requests',
  calls: 'Calls',
  first: 'First',
  second: 'Second',
  third: 'Third',
  fourth: 'Fourth',
  fifth: 'Fifth',
  sixth: 'Sixth',
  seventh: 'Seventh',
  saturday: 'Saturday',
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  preferredVisitWeekday: 'Preferred visit weekday',
  firstDay: 'First Day',
  secondDay: 'Second Day',
  thirdDay: 'Third Day',
  fourthDay: 'Fourth Day',
  fifthDay: 'Fifth Day',
  sixthDay: 'Sixth Day',
  seventhDay: 'Seventh Day',
  addFood: 'Add Food',
  editFood: 'Edit Food',
  foodDetails: 'Food Details',
  diets: 'Diets',
  dietType: 'Type of diet',
  foodTitle: 'Food Title',
  coefficient: 'Coefficient',
  foodItemNote: 'The sum of the coefficients of the food items must be 100.',
  saveFoodCaloryConfirm: 'Are you sure you want to save this calorie range?',
  recipe: 'Recipe',
  addCalorieRange: 'Add Calorie range',
  intervalNumberError: 'The range should be between {min} and {max}.',
  addRangeFrom: 'Add range from',
  toInfinity: 'To infinity',
  ratio: 'Ratio',
  forCaloriesFromRange: 'For calories from range',
  till: 'Till',
  completeTheFoodDetailsFirstBeforeContinuing: 'Complete the food details first before continuing.',
  leadDistributionRules: 'Lead Distribution Rules',
  leadDistributionRule: 'Lead Distribution Rule',
  sort: 'Sort',
  distributionPercentage: 'Distribution Percentage',
  olderThanMinutes: 'Older Than Minutes',
  newerThanMinutes: 'Until after',
  newest: 'Newest',
  oldest: 'Oldest',
  random: 'Random',
  minute: 'Minute',
  hour: 'Hour',
  timeInputCaption: 'Format: Days/Hours/Minutes',
  editMobileNumber: 'Edit mobile number',
  loginToYourAccount: 'Login to your account',
  salesAssociateInformation: 'Sales Associate Information',
  salesAssociateReview: 'Sales Associate Review',
  paymentAccounts: 'Payment Accounts',
  paymentAccount: 'Payment Account',
  cardNumber: 'Card Number',
  accountHolderName: 'Account holder name',
  mustBeExactlyNDigits: 'must Be Exactly {digit} Digits',
  identifier: 'Identifier',
  mobileNumber: 'Mobile number',
  behandam: 'Behandam',
  auth: 'Auth',
  categorization: 'Categorization',
  view: 'View',
  create: 'Create',
  update: 'Update',
  request: 'Request',
  call: 'Call',
  assign: 'Assign',
  content: 'Content',
  dynamic_builder: 'Dynamic builder',
  payment: 'Payment',
  product: 'Product',
  products: 'Products',
  editProduct: 'Edit Product',
  createProduct: 'Create Product',
  productTypes: 'Product Types',
  productType: 'Product Type',
  variantType: 'Variant Type',
  setting: 'Setting',
  ticket: 'Ticket',
  translation: 'Translation',
  country: 'Country',
  dynamic: 'Dynamic',
  static: 'Static',
  department: 'Department',
  attributes: 'Attributes',
  attribute: 'Attribute',
  attributeValue: 'Attribute Value',
  assign_role: 'Assign role',
  remove_role: 'Remove role',
  sync_roles: 'Sync roles',
  give_permission: 'Give permission',
  revoke_permission: 'Revoke permission',
  sync_permissions: 'Sync permissions',
  role: 'Role',
  permission: 'Permission',
  assignRole: 'Assign Role',
  removeRole: 'Remove Role',
  syncRoles: 'Sync Roles',
  givePermission: 'Give Permission',
  revokePermission: 'Revoke Permission',
  syncPermissions: 'Sync Permissions',
  manage: 'Manage',
  leadDistribution: 'Lead Distribution',
  lead: 'Lead',
  affiliate: 'Affiliate',
  returnRequests: 'Return Requests',
  returnRequest: 'Return request',
  refund: 'Refund',
  commissionRule: 'Commission Rule',
  commissionRules: 'Commission Rules',
  callTypes: 'Call Types',
  callPattern: 'Call Pattern',
  supportCall: 'Support Call',
  viewAllCalls: 'View All Calls',
  note: 'Note',
  affiliatePartner: 'Affiliate Partner',
  affiliatePartners: 'Affiliate Partners',
  affiliateLink: 'Affiliate Link',
  affiliateLinks: 'Affiliate Links',
  audit: 'Audit',
  post: 'Post',
  layout: 'Layout',
  section: 'Section',
  component: 'Component',
  componentType: 'Component Type',
  discount: 'Discount',
  wallet: 'Wallet',
  typeAttributes: 'Type Attributes',
  release: 'Release',
  recentlySearched: 'Recently Searched',
  noResultFound: 'No result found!',
  calculateWeight: 'Calculate weight',
  gender: 'Gender',
  age: 'Age',
  weight: 'Weight',
  height: 'Height',
  wristCircumference: 'Wrist circumference',
  dailyActivity: 'Daily activity',
  calculation: 'Calculation',
  addUnit: 'Add Unit',
  enterUnitName: 'Enter unit name',
  editUnit: 'Edit Unit',
  copiedSuccessfully: 'Copied successfully',
  summary: 'Summary',
  readingTime: 'Reading time',
  requestOtp: 'Request OTP',
  faqs: 'FAQs',
  addFaq: 'Add FAQ',
  editFaq: 'Edit FAQ',
  categories: 'Categories',
  question: 'Question',
  answer: 'Answer',
  enterQuestion: 'Enter question',
  enterAnswer: 'Enter answer',
  amount: 'Amount',
  paidAt: 'Paid at',
  rejectedAt: 'Rejected at',
  transactions: 'Transactions',
  pendingTransactions: 'Pending transactions',
  rejected: 'Rejected',
  notCanceledByUser: 'User Not Canceled',
  canceledByUser: 'User canceled',
  transactionMethod: 'Transaction method',
  wallets: 'Wallets',
  balance: 'Balance',
  blockBalance: 'Block balance',
  currency: {
    name: 'Currency name',
    symbol: 'Currency symbol',
    code: 'Currency code',
    title: 'currency'
  },
  key: 'Key',
  meta: 'Meta',
  uiType: 'UI Type',
  addComponent: 'Add component',
  editComponent: 'Edit component',
  parentComponent: 'Parent component',
  parent: 'Parent',
  enterName: 'Enter name',
  enterKey: 'Enter key',
  enterValue: 'Enter value',
  foodReplacementReport: 'Food replacement report',
  userType: 'User type',
  event: 'Event',
  auditableType: 'Auditable type',
  oldValues: 'Old values',
  newValues: 'New values',
  ipAddress: 'IP address',
  userAgent: 'User agent',
  reservedAt: 'Reserved at',
  suspendedAt: 'Suspended at',
  finished: 'Finished',
  unFinished: 'Unfinished',
  unmark: 'Unmark',
  cancelCompletion: 'Cancel completion',
  markAsUnfinished: 'Mark as unfinished',
  markAsfinished: 'Mark as finished',
  refresh: 'Refresh',
  noPermissionToUnmark: 'You do not have permission to change the finished status',
  group: 'Group',
  callWasSuccessful: 'The call was successful',
  theyCallThemselves: 'They call themselves',
  calledDidntAnswer: 'Called, didn\'t answer',
  notAvailable: 'Not available',
  phoneWasOff: 'Their phone was off',
  rejectedTheCall: 'They rejected the call.',
  theyAreBusy: 'They are busy',
  numberWasWrong: 'The number was wrong',
  callLater: 'Call later',
  audienceIsAbroad: 'The audience is abroad.',
  lastStatus: 'Last status',
  confirmReleaseUserInfo: 'If approved, this user will be removed from the list of held calls and other experts will be able to contact this user.',
  confirmReleaseTicketsAssignment: 'If approved, tickets assigned to this affiliate partner will be released and made available to other experts.',
  releaseNewAssignments: 'Release new assignments',
  confirmReleaseNewAssignments: 'If approved, new assignments for this affiliate partner will be released and made available to other experts.',
  userProfile: 'User Profile',
  mealCompliance: 'Meal Compliance',
  dietVideos: 'Diet Videos',
  dietVideo: 'Diet Video',
  videoPost: 'Video Post',
  videoPosts: 'Video Posts',
  selectDiet: 'Select Diet',
  recalculateRemainingDays: 'Recalculate remaining days based on value',
  selectVideoPost: 'Select Video Post',
  selectVideoPosts: 'Select Video Posts',
  bulkAssociate: 'Bulk Associate',
  bulkAssociateInfo: 'Bulk Association Information',
  bulkAssociateDescription: 'This will associate multiple video posts with the selected diet. The order index will start from the specified number and increment for each post.',
  bulkAssociateSuccess: 'Videos associated successfully',
  associate: 'Associate',
  startOrderIndex: 'Start Order Index',
  editDietVideo: 'Edit Diet Video',
  selectedVideos: 'Selected Videos',
  orderIndex: 'Order Index',
  activate: 'Activate',
  deactivate: 'Deactivate',
  contentCommunications: 'Content & Communications',
  salesFinance: 'Sales & Finance',
  supportTickets: 'Support & Tickets',
  systemSettings: 'System Settings',
  nutritionHealth: 'Nutrition & Health',
  trainingSurveys: 'Training & Surveys',
  activitiesReports: 'Activities & Reports',
  weightLoss: 'Weight loss',
  weightGain: 'Weight gain',
  stabilization: 'Stabilization',
  pregnancy: 'Pregnancy',
  registerPackage: 'Register package',
  startTerm: 'Start term',
  renewal: 'Renewal',
  getMenu: 'Get menu',
  financeHistory: 'Finance history',
  viewUserFinancialHistory: 'View user financial history',
  digital: 'Digital',
  physical: 'Physical',
  service: 'Service',
  diet: 'Diet',
  package: 'Package',
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  block: 'Block',
  unblock: 'Unblock',
  courseLength: 'Course Length',
  remainingDays: 'Remaining days',
  supportCallType: 'Support Call Type',
  supportCallTypes: 'Support Call Types',
  supportCallPatterns: 'support Call Patterns',
  supportCallPattern: 'Support Call Pattern',
  metadata: 'Meta Data',
  isFree: 'is Free',
  hero: 'Hero',
  firstWeight: 'First Weight',
  lastWeight: 'Last Weight',
  body: 'Body',
  views_count: 'Views Count',
  views: 'Views',
  rating: 'Rating',
  foodReplacement: 'Food Replacement',
  paused: 'Paused',
  registerPackageMessageTermState: 'Registering a food list requires an active package',
  startTermMessageTermState: 'Registering a food list requires an active term',
  renewalMessageTermState: 'Registering a food list requires an active term',
  getMenuMessageTermState: 'Food list not received',
  visitMessageTermState: 'To register a basic list, create one first',
  underweight: 'Underweight',
  normal: 'Normal',
  obesityClass1: 'Obesity Class 1',
  overweight: 'Overweight',
  obesitycClass2: 'Obesity Class 2',
  obesityClass3: 'Obesity Class 3',
  library: 'Library',
  upload_files: 'Upload Files',
  allocationSalesCollaboration: 'Allocation of sales collaboration (reserve)',
  manual: 'Manual',
  show_wallet: 'Show Wallet',
  increase_amount: 'Increase Amount',
  decrease_amount: 'Decrease AMount',
  block_amount: 'Block AMount',
  unblock_amount: 'Unblock AMount',
  toman: 'Toman',
  end_of_list: 'End of List',
  typeMessage: 'Type Message ...',
  simple: 'Simple',
  configurable: 'Configurable',
  end: 'End',
  emailOrMobileRequired: 'Email or mobile is required.',
  referenceTo: 'Reference To',
  userTickets: 'User Tickets',
  medicalDocument: 'Medical Document',
  heroes: 'Heroes',
  addhero: 'Add Hero',
  waitingList: 'Waiting List',
  waiting: 'Waiting',
  completed: 'Completed',
  allReturnRequests: 'All Returns',
  onlineShoppingReturns: 'Online Shopping Returns',
  affiliatorReturns: 'Affiliator Returns',
  reason: 'Reason',
  employees: 'Employees',
  usersGenerateOtp: 'Users Generate OTP',
  salesPastYears: 'Past Years',
  usersLogin: 'Users Login',
  usersRoles: 'Users Roles',
  usersPermissions: 'Users Permissions',
  leads: 'Leads',
  leadsRequestAssignment: 'Leads Request Assignment',
  leadsReleaseAssignments: 'Leads Release Assignments',
  leadsCalls: 'Leads Calls',
  affiliatesAssignmentsActive: 'Affiliates Assignments Active',
  affiliatesAssignments: 'Affiliates Assignments',
  affiliatesCommissionsRules: 'Affiliates Commissions Rules',
  affiliatesPartners: 'Affiliates Partners',
  affiliatesPartner: 'Affiliates Partner',
  affiliatesPartnersExternal: 'Affiliates Partners External',
  affiliatesLinks: 'Affiliates Links',
  supportCallHistories: 'Support Call Histories',
  supportCalls: 'Support Calls',
  supportCallsRequestAssignment: 'Support Calls Request Assignment',
  supportCallsReleaseAssignments: 'Support Calls Release Assignments',
  supportCallReporting: 'Support call reporting',
  notes: 'Notes',
  heroesImport: 'Heroes Import',
  audits: 'Audits',
  terms: 'Terms',
  termsExpiration: 'Terms Expiration',
  termMenus: 'Term Menus',
  termMenusApprove: 'Term Menus Approve',
  visits: 'Visits',
  bodyMetrics: 'Body Metrics',
  usersTerms: 'Users Terms',
  usersTermsActive: 'Users Terms Active',
  usersVisitsActive: 'Users Visits Active',
  usersMenusActive: 'Users Menus Active',
  usersDiet: 'Users Diet',
  usersPendingCall: 'Users Pending Call',
  usersPregnancyWeek: 'Users Pregnancy Week',
  pregnancyWeek: 'Pregnancy Week',
  usersDiseases: 'Users Diseases',
  stateSync: 'State Sync',
  userStatsActiveTerm: 'User Stats Active Term',
  userStatsWeight: 'User Stats Weight',
  userStatsCalendar: 'User Stats Calendar',
  options: 'Options',
  optionTypeDietGoal: 'Diet Goal',
  optionTypeDietHistory: 'Diet History',
  optionTypeActivityLevel: 'Daily Activity Level',
  optionTypeSupportCallStatus: 'Support Call Status',
  tagsTypes: 'Tags Types',
  categoriesSubCategories: 'Categories SubCategories',
  posts: 'Posts',
  productPostSchedule: 'Product Post Schedule',
  componentTypes: 'Component Types',
  layoutsComponents: 'Layouts Components',
  formsWithQuestions: 'Forms With Questions',
  questions: 'Questions',
  responses: 'Responses',
  comments: 'Comments',
  fastingPatterns: 'Fasting Patterns',
  fastingPatternsMeals: 'Fasting Patterns Meals',
  foodsCalory: 'Foods Calory',
  foodsMeals: 'Foods Meals',
  foodsCalories: 'Foods Calories',
  foodsReplicateCalory: 'Foods Replicate Calory',
  foodCalories: 'Food Calories',
  foodCaloriesFoodItems: 'Food Calories Food Items',
  foodItemsDiseases: 'Food Items Diseases',
  foodItemsUnits: 'Food Items Units',
  foodItemDiseases: 'Food Item Diseases',
  foodItemUnits: 'Food Item Units',
  mealsDiseases: 'Meals Diseases',
  menus: 'Menus',
  menusCalories: 'Menus Calories',
  menusReplicate: 'Menus Replicate',
  menuCalories: 'Menu Calories',
  menuCaloriesReplicate: 'Menu Calories Replicate',
  menuCaloryDays: 'Menu Calory Days',
  menuCaloryDaysMeals: 'Menu Calory Days Meals',
  menuCaloryDayMeals: 'Menu Calory Day Meals',
  menuCaloryDayMealsFoods: 'Menu Calory Day Meals Foods',
  menuCaloryDayMealsOrder: 'Menu Calory Day Meals Order',
  menuCaloryDayMealFoods: 'Menu Calory Day Meal Foods',
  menuPeriods: 'Menu Periods',
  recommends: 'Recommends',
  units: 'Units',
  userMenus: 'User Menus',
  userMenusGenerate: 'User Menus Generate',
  userMenusWeeks: 'User Menus Weeks',
  userMenusMeals: 'User Menus Meals',
  userMenuDays: 'User Menu Days',
  userMenuDaysMeals: 'User Menu Days Meals',
  userMenuDayMeals: 'User Menu Day Meals',
  userMenuDayMealsFoods: 'User Menu Day Meals Foods',
  userMenuDayMealsOrder: 'User Menu Day Meals Order',
  userMenuDayMealFoods: 'User Menu Day Meal Foods',
  userMenuDayMealFoodsFoodItems: 'User Menu Day Meal Foods Food Items',
  mediaFolders: 'Media Folders',
  devices: 'Devices',
  notifications: 'Notifications',
  notificationsCategories: 'Notifications Categories',
  ordersInvoice: 'Orders Invoice',
  ordersSystemPackage: 'Orders System Package',
  ordersFastOrders: 'Orders Fast Orders',
  returnRequestsOnline: 'Return Requests Online',
  returnRequestsAffiliate: 'Return Requests Affiliate',
  returnRequestsRefund: 'Return Requests Refund',
  walletsUser: 'Wallets User',
  walletsDeposit: 'Wallets Deposit',
  walletsWithdraw: 'Wallets Withdraw',
  walletsBlock: 'Wallets Block',
  walletsUnblock: 'Wallets Unblock',
  walletsTransactions: 'Wallets Transactions',
  transactionLogs: 'Transaction Logs',
  admin_id: 'Admin ID',
  rejected_at: 'Rejected At',
  gateway_ref_id: 'Gateway Ref ID',
  card_media_id: 'Card Media ID',
  card_owner: 'Card Owner',
  card_number: 'Card Number',
  sheba_number: 'Sheba Number',
  tracking_code: 'Tracking Code',
  paid_at: 'Paid At',
  updated_at: 'Updated At',
  changesDetails: 'Changes Details',
  viewTransactionLogs: 'View Transaction Logs',
  walletsWithdrawalRequests: 'Wallets Withdrawal Requests',
  userCards: 'User Cards',
  userCompanyCard: 'Company card - user',
  productsForm: 'Products Form',
  productsAttributesSearch: 'Products Attributes Search',
  types: 'Types',
  typesModels: 'Types Models',
  typesAttributesReorder: 'Types Attributes Reorder',
  typesAttributes: 'Types Attributes',
  ticketsParticipation: 'Tickets Participation',
  ticketsStatus: 'Tickets Status',
  ticketsCurrentStatusByDepartment: 'Tickets Current Status By Department',
  supportCallsCurrentStatusByType: 'Support Calls Current Status By Type',
  salePanel: 'Sale Panel',
  salesDaily: 'Sales Daily',
  salesTotal: 'Sales Total',
  salesProducts: 'Sales Products',
  salesReturned: 'Sales Returned',
  salesAffiliate: 'Sales Affiliate',
  salesSales: 'Sales Sales',
  salesRegistrations: 'Sales Registrations',
  salesRenewals: 'Sales Renewals',
  salesTopCustomerOrigins: 'Sales Top Customer Origins',
  leadsCount: 'Leads Count',
  callsTotal: 'Calls Total',
  releases: 'Releases',
  tenants: 'Tenants',
  tenantsConfigs: 'Tenants Configs',
  departmentsUsers: 'Departments Users',
  departments: 'Departments',
  ticketsActivityLogs: 'Tickets Activity Logs',
  ticketsRequestAssignment: 'Tickets Request Assignment',
  ticketsReleaseAssignment: 'Tickets Release Assignment',
  ticketsMessages: 'Tickets Messages',
  usersMyPermissions: 'Users My Permissions',
  usersBlocks: 'Users Blocks',
  usersSearch: 'Users Search',
  usersDeletedAccount: 'Users Deleted Account',
  medicalDocuments: 'Medical Documents',
  addresses: 'Addresses',
  notification: 'Notification',
  feedback: 'Feedback',
  report: 'Report',
  percent: 'Percent',
  rules: 'Rules',
  target: 'Target',
  targetType: 'Target Type',
  targetId: 'Target ID',
  affectedUser: 'Affected User',
  requestedBy: 'Requested By',
  appliedBy: 'Reviewed By',
  appliedAt: 'Reviewed At',
  reviewNote: 'Review Note',
  entityType: 'Entity type',
  entity: 'Entity',
  extraCommission: 'Extra Commission',
  commission: 'Commission',
  commissionType: 'Commission Type',
  redirectUrl: 'Redirect Url',
  clickCount: 'click Count',
  affiliatableType: 'Affiliatable Type',
  uniqueIdentifier: 'Unique identifier',
  discountCode: 'Discount code',
  registrationsChart: 'Registrations Chart',
  renewalsChart: 'Renewals Chart',
  paymentsChart: 'Payments Chart',
  expertsCallsReport: 'Experts Calls Report',
  callReports: 'Call Reports',
  reports: 'Reports',
  requestedNumbersReport: 'Requested Numbers Report',
  numbersStatusReport: 'Numbers Status Report',
  requestedNumbersReportByInputChannel: 'Requested Numbers Report by Input Channel',
  affiliateSalesReport: 'Affiliate Sales Report',
  affiliateSalesReportDetails: 'Affiliate Sales Report Details',
  affiliateSalesReportExternal: 'Affiliate Sales Report External',
  affiliateAssignments: 'Affiliate Assignments',
  searchByMobileOrName: 'Search by ID, Mobile or Name',
  hasPaidOrder: 'Has Paid Order',
  totalSalesReport: 'Total Sales Report',
  dailySalesReport: 'Daily Sales Report',
  totalSalesReportByPackage: 'Total Sales Report by Package',
  totalPackageReturnsReport: 'Total Package Returns Report',
  inputChannelsReport: 'Input Channels Report',
  ticketParticipationReport: 'Ticket Participation Report',
  ticketsStatusReport: 'Tickets Status Report',
  affiliatableName: 'Affiliatable Name',
  confirmedCommission: 'Confirmed Commission',
  confirmedSale: 'Confirmed Sale',
  confirmedSalesCount: 'Confirmed Sales Count',
  unconfirmedSalesCount: 'Unconfirmed Sales Count',
  conversionRate: 'Conversion Rate',
  nonPurchasersCount: 'Non Purchasers Count',
  payableCommission: 'Payable Commission',
  returnCommission: 'Return Commission',
  returnedSalesCount: 'Returned Sales Count',
  salesProductsReport: 'Product Sales Report',
  countUnit: 'Units',
  totalNetSales: 'Total Net Sales',
  returnAmount: 'Return Amount',
  totalDiscounts: 'Total Discounts',
  netSales: 'Net Sales',
  totalSalesCount: 'Total Sales Count',
  averagePrice: 'Average Price',
  totalSalesLabel: 'Total Sales',
  totalCountLabel: 'Total Count',
  returnedCountLabel: 'Returned Count',
  returnAmountLabel: 'Return Amount',
  finalIncomeLabel: 'Final Income',
  unconfirmedCommission: 'Unconfirmed Commission',
  unconfirmedSale: 'Unconfirmed Sale',
  total: 'Total',
  inboundCount: 'Inbound Count',
  outboundCount: 'Outbound Count',
  lineChart: 'Line Chart',
  barChart: 'Bar Chart',
  pieChart: 'Pie CHart',
  bubbleChart: 'Bubble Chart',
  table: 'Table',
  count: 'Count',
  totalCalls: 'Total Call',
  saleCount: 'Sale Count',
  themeMode: 'Theme Mode',
  light: 'Light',
  dark: 'Dark',
  rtlMode: 'RTL Mode',
  rtl: 'rtl',
  widthMode: 'Width Mode',
  fluid: 'Fluid',
  iconStyle: 'Icon Style',
  sidebarMenuIcon: 'sidebarMenuIcon',
  Layouts: 'Layouts',
  reset: 'Reset',
  lightSidebar: 'Light Sidebar',
  darkSidebar: 'Dark Sidebar',
  signOut: 'Sign Out',
  myProfile: 'My Profile',
  associateSalesReport: 'Associate sales report',
  distributionType: 'Distribution Type',
  distributionPriority: 'Distribution Priority',
  duration: 'List duration (day)',
  multiplePregnancy: 'Multiple Pregnancy',
  diabetes: 'Diabetes',
  lactation: 'Lactation',
  usual: 'Usual',
  special: 'Special',
  blocker: 'Blocker',
  otherInformation: 'Other information',
  assignedAt: 'Assigned At',
  customerOriginUpdatedAt: 'Customer Origin Updated At',
  availableAt: 'Available At',
  birthdate: 'Birth Date',
  male: 'Male',
  female: 'Female',
  commonGender: 'Both',
  orderCode: 'Order Code',
  startsAt: 'Starts At',
  expiresAt: 'Expires At',
  author: 'Author',
  mostViewed: 'Most Viewed',
  mostWeightLoss: 'Most Weight Loss',
  mostWeightGain: 'Most Weight Gain',
  affectingUserDisease: 'Affecting User Disease',
  subcategories: 'Subcategories',
  activeAccounts: 'Active Accounts',
  abbreviation: 'Disease Abbreviation',
  subdiseases: 'Subcategory diseases',
  bankCard: 'Bank card',
  startDate: 'Start date',
  endDate: 'End date',
  created: 'created',
  updated: 'Updated',
  deleted: 'Deleted',
  activities: 'Activities',
  releaseAssignment: 'Release assignment',
  output: 'Output',
  fileName: 'File name',
  getOutput: 'Get output',
  id: 'id',
  oldId: 'Old ID',
  columnHeaders: 'column headers',
  excelOutput: 'Excel output',
  importExcel: 'Import excel',
  file: 'File',
  conversationTopics: 'Conversation Topics',
  smsTemplates: 'SMS Templates',
  smsTemplate: 'SMS Template',
  addSmsTemplate: 'Add SMS Template',
  editSmsTemplate: 'Edit SMS Template',
  driver: 'Driver',
  selectDriver: 'Select driver',
  templateId: 'Template ID',
  enterTemplateId: 'Enter template ID',
  enterLabel: 'Enter label',
  sampleText: 'Sample text',
  enterSampleText: 'Enter sample text',
  isPlain: 'Plain text',
  isPublic: 'Public',
  tokens: 'Tokens',
  tokenName: 'Token name',
  tokenValue: 'Token value',
  addToken: 'Add token',
  tokensHelperTitle: 'Tokens guide',
  tokensHelperText: 'Token name (key) is sent to the SMS provider and token value is used for auto-filling in the admin dashboard. Supported values: name (user name), admin (admin name), adminPhone (admin phone)',
  sampleTextHelper: 'Variables must start with %. Example: %TOKEN, %token10, %NAME',
  plain: 'Plain',
  item: 'Item',
  callHistory: 'Call History',
  isCommissionCanceller: 'Is Commission Canceller',
  withdrawalRequests: 'Withdrawal Requests',
  withdrawalRequest: 'Withdrawal Request',
  unassigned: 'Unassigned',
  uncompleted: 'Uncompleted',
  waitingReply: 'Waiting Reply',
  successfulCalls: 'Successful Calls',
  successPercentage: 'Success Percentage',
  callcenter: 'Call Center',
  extensions: 'Extensions',
  referral: 'Referral link',
  admins: 'Admins',
  supervisor: 'Supervisor',
  affiliates: 'Affiliates',
  supportConversationTopics: 'Support Conversation Topics',
  supportCallHistoriesTopics: 'Call history',
  leadsImport: 'Entering numbers via Excel',
  taggables: 'Tags',
  specialCondition: 'Special Condition',
  mealsOrder: 'Sorting meals',
  leadsCallsStats: 'Leads Calls Stats',
  leadsCallsByAdmin: 'Leads Calls By Admin',
  leadsCallsByStatus: 'Leads Calls By Status',
  leadsCallsByDate: 'Leads Calls By Date',
  sales: 'Sales',
  supportCallsStats: 'Support Calls Stats',
  ticketsReleaseAssignments: 'Assign tickets',
  callsMakeCall: 'Make Call',
  callsCheckNew: 'Check New',
  queues: 'Queues',
  queueMembers: 'Queue Members',
  gamification: 'Gamification',
  badges: 'Badges',
  date: 'Date',
  commissions: 'Commissions',
  commissionSettlement: 'Commission settlement',
  recalculateCommission: 'Recalculate commission',
  orderPaymentDate: 'Order payment date',
  confirmRecalculateCommission: 'This order\'s commission will be recalculated based on the latest commission rule. Are you sure?',
  deductedAmount: 'Deducted Amount',
  iban: 'Sheba Bank number',
  userCard: 'Bank card',
  checkNetworkConnection: 'Please check your internet connection and try again.',
  tryAgain: 'Try again',
  flowManagement: 'Flow Management',
  flow: 'flow',
  flowConstruction: 'Flow construction',
  notStarted: 'Not Started',
  usersBankCards: 'Users bank cards',
  cardholderName: 'Cardholder name',
  noResultsFound: 'No Results Found.',
  obesity_class_1: 'obesity_class_1',
  obesity_class_2: 'obesity_class_2',
  obesity_class_3: 'obesity_class_3',
  menu: 'Menu',
  support: 'support',
  calorieRange: 'Calorie range',
  calorieInfoChangeUpdateFoodList: 'As the information changes, the calorie intake changes and as a result, the food list changes; it is recommended that the food list be updated.',
  addConfig: 'Add config',
  hasTicket: 'Submit a ticket',
  filter: 'Filter',
  clear: 'Clear',
  nextMenuDate: 'Next Menu Date',
  pregnancyStartDate: 'Pregnancy Start Date',
  processSlug: 'Process Slug',
  processData: 'Process Data',
  paymentNumber: 'Payment Number',
  trackingCode: 'Tracking Code',
  bankReferenceNumber: 'Bank reference number',
  paymentType: 'Payment type',
  link: 'Link',
  paymentDate: 'Payment date',
  clearAndClose: 'Clear and close',
  orderDate: 'Order date',
  shopping: 'Shopping',
  systemic: 'Systemic',
  financialOperations: 'Financial operations',
  awaitingSplit: 'Awaiting split',
  awaitingReferralSplit: 'Awaiting referral split',
  returnDeadline: 'Return deadline',
  signupDate: 'Sign-up Date',
  randomStringLength: 'Random string length',
  prefix: 'Prefix',
  suffix: 'Suffix',
  couponPrefix: 'Prefix (Latin letters and numbers only)',
  couponSuffix: 'Extension (Latin letters and numbers only)',
  onlyFirstBy: 'For the first purchase',
  filtering: 'Filtering',
  unfinished: 'Unfinished',
  convinced: 'Convinced',
  notConvinced: 'Not convinced',
  newVersionAvailable: 'A new version is available',
  reloadPage: 'Reload page',
  activeTimeFrame: 'Active time frame',
  firstOrderOnly: 'First order only',
  assignToProduct: 'Assign to product',
  message: 'Message',
  callResult: 'Call result',
  callStatus: 'Call status',
  purchaseProbability: 'Purchase probability',
  priceStatus: 'Price status',
  noProblem: 'No problem',
  discountOrInstallment: 'Wants installment or discount',
  wantsFree: 'Wants it for free',
  purchased: 'Purchased',
  noPlan: "Doesn't want a plan",
  noAnswer: 'No answer',
  callAgain: 'Call again',
  needFreeConsult: 'Needs free consultation',
  ableToBuy: 'Able to purchase',
  reservedByOther: 'Reserved by another expert',
  userHungUp: 'User hung up',
  notAwareOfCall: 'Was not aware of the call request',
  hasDiet: 'Already has a diet',
  callSuccessful: 'Call completed successfully',
  phoneOff: "Contact's phone was off",
  unavailable: 'Unavailable',
  rangNoAnswer: 'Rang but no answer',
  busy: 'Line was busy',
  wrongNumber: 'Wrong number',
  willCallBack: 'Will call back themselves',
  international: 'Contact is abroad / international',
  processed: 'Processed',
  salesReport: 'Sales report',
  address: 'Address',
  postalcode: 'Postal code',
  province: 'Province',
  city: 'City',
  calory: 'Calory',
  card: 'Card',
  admin: 'Admin',
  daysAfterStart: 'Days after start',
  myNumbers: 'My numbers',
  referenceCount: 'Reference Count',
  soldCount: 'Sold Count',
  referenceAmount: 'Reference Amount',
  totalGrossSales: 'Total Gross Sales',
  shop: 'Shop',
  currentInventory: 'Current Inventory from Counts and Account-to-Account',
  parsianGateway: 'Parsian Gateway',
  samanGateway: 'Saman Gateway',
  mellatGateway: 'Mellat Gateway',
  zarinpalGateway: 'ZarinPal Gateway',
  snapPay: 'Snap Pay',
  latestIssues: 'Latest issues',
  lastCallDate: 'Last call date',
  noReportsToDisplay: 'There are no reports to display in the selected range.',
  dedicated: 'Dedicated',
  withoutExpert: 'Without an expert',
  answered: 'Answered',
  searchByPartnerName: 'Search by partner name',
  partnerType: 'Partner Type',
  internalAffiliat: 'Internal',
  externalAffiliat: 'Organizational',
  assignementType: 'Assignement Type',
  paymentPending: 'Payment pending',
  partiallyReturned: 'Partially returned',
  oldSoftwareMigration: 'Migration Status',
  totalActiveUsers: 'Total Users',
  totalMigratedUsers: 'Migrated Users',
  totalActiveUsersWithActiveTerms: 'Active Users with Active Terms',
  usersWithActiveTerms: 'Users with Active Terms',
  usersWithoutActiveTerms: 'Users without Active Terms',
  usersWithPayment: 'Users with at least one payment',
  migrateSelected: 'Migrate Selected',
  hasPayment: 'Has payment',
  noPayment: 'No payment',
  paymentStatus: 'Payment status',
  migrationStatus: 'Migration Status',
  migrated: 'Migrated',
  notMigrated: 'Not Migrated',
  checkPoint: 'Check Point',
  includeDeleted: 'Include Deleted',
  termInfo: 'Term Information',
  conditionInfo: 'Condition Information',
  startedAt: 'Started At',
  expiredAt: 'Expired At',
  extraDays: 'Extra Days',
  isStopped: 'Is Stopped',
  userDetails: 'User Details',
  oldSoftwareUsers: 'Old Software Users',
  noTerms: 'No terms registered',
  noCondition: 'No condition registered',
  migrationSuccess: 'User migrated successfully',
  migrationFailed: 'Failed to migrate user',
  migrateUser: 'Migrate user',
  proceedAnyway: 'Proceed anyway',
  forceMigrateConfirmCancel: 'Cancel',
  oldPanel: 'Old Panel',
  newPanel: 'New Panel',
  vipUsers: 'VIP Users',
  migrationInProgress: 'Migrating users...',
  migratedCount: '{count} of {total} users migrated',
  errorsCount: '{count} errors',
  migrationErrors: 'Migration Errors',
  clearErrors: 'Clear',
  andMoreErrors: 'and {count} more errors...',
  migrateAll: 'Migrate all',
  fetchUserIdsFailed: 'Failed to fetch user list',
  batchMigrationComplete: '{count} users migrated successfully',
  migrationLog: 'Migration Log',
  successCount: 'Success',
  errorCount: 'Errors',
  stopMigration: 'Stop',
  clearLog: 'Clear',
  migratingUser: 'Migrating user {id}...',
  waitingForResults: 'Waiting for results...',
  activeTerm: 'Active Term',
  hasActiveTerm: 'Has Active Term',
  noActiveTerm: 'No Active Term',
  vipStatus: 'VIP Status',
  isVip: 'VIP User',
  notVip: 'Not VIP',
  alternativeTitle: 'Alternative title',
  activateFasting: 'Activate fasting',
  defaultFasting: 'Default Fasting',
  priceType: 'Price type',
  price: 'Price',
  specialPrice: 'Special price',
  specialDiscountDescription: 'Special discount description',
  commissionBasePrice: 'Commission base price',
  strategies: 'Strategies',
  distributionStrategies: 'Distribution Strategies',
  dragOrSelectUsersHere: 'Drag or select users here',
  distributionList: 'Distribution list',
  lastAssignedUser: 'Last assigned user',
  strategy: 'Strategy',
  assignedCount: 'Sssigned count',
  addRule: 'Add rule',
  selectTypeToView: 'Select type to view',
  selectStrategyType: 'Select strategy type',
  font: 'Font',
  fontIranSanse: 'Iran Sanse',
  fontIranYekan: 'Iran Yekan',
  fontNegaar: 'Negaar',
  settlementStatus: 'Settlement status',
  systemicLeads: 'Systemic leads',
  incompleteRegistration: 'Incomplete registration',
  nonRenewal: 'Non renewal',
  incompleteRegistrationIncomplete_payment: 'Incomplete registration incomplete payment',
  nonRenewalIncompletePayment: 'Non renewal incomplete payment',
  userState: 'User state',
  totalNumber: 'Total number',
  PaymentDate: 'Payment date',
  amountType: 'Amount type',
  haveSalesExpert: 'Have a sales expert',
  sharedOrder: 'Shared order',
  hasFastPro: 'Has fast pro',
  orderRequest: 'Order',
  orderStatus: 'Order status',
  commandRequestCommand: 'command',
  commandRequestSource: 'source',
  system: 'system',
  allocationRule: 'Allocation Rules',
  addAllocationRule: 'Add New Smart Portal',
  editAllocationRule: 'Edit Allocation Rule',
  allocationRuleDetail: 'Allocation Rule Detail',
  allocationRuleDeleteConfirm: 'Are you sure you want to deactivate this smart portal?',
  allocationRuleArchiveTitle: 'Archive Smart Portal',
  allocationRuleArchiveConfirm: 'Are you sure you want to archive this smart portal?',
  allocationRuleResetCycleConfirm: 'By activating this smart portal, the current active smart portal will be deactivated. Are you sure?',
  allocationMode: 'Revenue Distribution Mode',
  visibilityMode: 'Visibility Mode',
  periodDays: 'Period (days)',
  ruleAccounts: 'Rule Accounts',
  activeCycle: 'Active Cycle',
  paymentAccountId: 'Payment Account ID',
  targetPercentage: 'Target Percentage',
  maxAllocationAmount: 'Max Allocation Amount',
  accountsCount: 'Accounts Count',
  activatedAt: 'Activated At',
  percentageBased: 'Percentage Based',
  allocationFixedAmount: 'Fixed Amount',
  allocationDraft: 'Draft',
  allocationArchived: 'Archived',
  allocationArchive: 'Archive',
  allocationFiltered: 'Filtered',
  allocationSuggested: 'Suggested',
  allocationPercentage: 'Allocation Percentage',
  mustBe100: 'Total must equal 100%',
  resetCycle: 'Reset Cycle',
  resetCycleConfirm: 'Are you sure you want to reset the active cycle?',
  addAccount: 'Add Account',
  addGateway: 'Add Gateway',
  allocationConfiguration: 'Allocation Configuration',
  allocationProgress: 'Progress',
  allocationAllocated: 'Allocated',
  allocationTarget: 'Target',
  days: 'days',

  generalSettings: 'General Settings',
  filtered: 'Filtered',
  filteredDescription: 'Show payment accounts filtered by defined conditions',
  suggested: 'Suggested',
  suggestedDescription: 'Suggest payment accounts to users without requiring selection',
  percentageBasedDescription: 'A percentage of revenue is automatically allocated to each account',
  fixedAmountDescription: 'A fixed maximum amount is allocated to each account per cycle',
  numberOfAccounts: 'Number of Accounts',
  totalPercentage: 'Total Percentage',
  remaining: 'Remaining',
  mustEqual100: 'Total percentage must equal exactly 100%',
  allocationComplete: 'Allocation is complete',
  allocationReadyToSave: 'You can save the rule now',
  exceeded: 'Exceeded',
  ruleNotFound: 'Allocation rule not found or you do not have access',
  remove: 'Remove',
  paymentGateway: 'Payment Gateway',

  calorieFormulas: 'Calorie Formulas',
  addCalorieFormula: 'Add Calorie Formula',
  editCalorieFormula: 'Edit Calorie Formula',
  calorieFormula: 'Calorie Formula',
  systemDefaultLeaveEmpty: 'System default (leave empty)',
  isDefaultFormula: 'Default Formula',
  variants: 'Variants',
  variant: 'Variant',
  add: 'Add',
  ageMin: 'Minimum Age',
  ageMax: 'Maximum Age',
  heightUnit: 'Height Unit',
  centimeter: 'Centimeter',
  meter: 'Meter',
  formulaTerms: 'Formula Terms',
  formulaPreview: 'Formula',
  variable: 'Variable',
  constant: 'Constant',
  scaledByActivity: 'Scaled by Activity',
  activityLevels: 'Activity Levels',
  deductionOptions: 'Calorie Adjustment Options',
  delta: 'Adjustment (kcal)',
  adjustmentRatio: 'Adjustment Ratio',
  increase: 'increase',
  decrease: 'decrease',
  percentEffect: '{percent}% {direction}',
  kcalEffect: '{amount} kcal {direction}',
  noEffect: 'no change',
  deductionRuleSummary: 'If {condition}: {effect}',
  eligibility: 'Eligibility Conditions',
  bmi: 'BMI',
  label: 'Label',
  noVariantsYet: 'No variants added yet.',
  noTermsYet: 'No terms added yet.',
  legacyFormulaImmutable: 'This is the system default formula and cannot be edited or deleted.',
  anyDietType: 'Not scoped by diet type',
  baseCalorie: 'Base calorie (computed)',
  goalBmiDiffSmall: 'BMI gap to goal is small',
  activityOption: 'Activity option',
  selectActivityOption: 'Select an activity level from the list',
  lessThan: 'Less than',
  lessThanOrEqual: 'Less than or equal to',
  greaterThan: 'Greater than',
  greaterThanOrEqual: 'Greater than or equal to',
  equalTo: 'Equal to',
  from: 'From',
  to: 'To',
  unlimitedAge: 'No age limit',
  noConditions: 'No condition (always applies)',
  noActivityLevelsDefined: 'No activity levels (ratio of 1 is used)',
  viewCalorieFormula: 'View Calorie Formula',
  and: 'and',
  atLeast: 'At least',
  searchVariants: 'Search variants...',
  moveUp: 'Move up',
  moveDown: 'Move down',
  expandVariantToPreview: 'Open a variant to see its preview.',
  sampleCalculation: 'Sample Calculation',
  result: 'Result',
  caloriesPerDay: 'kcal / day',
  appliedOption: 'Applied option',
  activityLevel: 'Activity level',
  selectActivityOptionWarning: 'Select an activity level',
  conditionCount: '{n} conditions',
  transcribe: 'Transcribe',
  transcript: 'Transcript',
  transcriptionPending: 'Transcribing...',
  transcriptionFailed: 'Transcription failed',
  editTranscript: 'Edit transcript',
  saveTranscript: 'Save transcript',
  retry: 'Retry',
  correctedTranscript: 'Corrected transcript',
  originalTranscript: 'Original transcript',
  correctedAt: 'Corrected at',
  viewOriginal: 'View original',
  viewCorrected: 'View corrected',
  editingTranscript: 'Editing transcript',
  segmentsChanged: '{count} segment(s) changed',
  changed: 'Changed',
  playSegment: 'Play this segment',
  noSegments: 'No segments available for this transcript.',
  playbackSpeed: 'Playback speed',
  downloadAudio: 'Download audio',
  transferTerm: 'Transfer term',
  destinationUser: 'Destination user'
};
export default en;
